import React from 'react';
import { useSelector } from 'react-redux';
import { Typography, Grid, Box } from '@mui/material';
import Typography500 from 'views/common/components/UI/Typography500';
import {
  StyledBox,
  StyledGridsGallery,
} from 'views/experience-module/MotorcycleTripView/components/MotorcycleTripsSection/MotorcycleTripsSection.styles';
import { prepareGalleryObject } from 'views/experience-module/MotorcycleTripView/utils/prepareGalleryObject';
import { useTranslation } from 'next-i18next';
import dynamic from 'next/dynamic';
import CollectionsIcon from '@mui/icons-material/Collections';

const ShareList = dynamic(() => import('views/common/components/UI/ShareList/ShareList'));
const MotorcycleTripsSection = (props) => {
  const { experiencePageData } = props;
  const { t } = useTranslation('fe_er_motorcycle_trip_page');
  const isCrawler = useSelector((state) => state.globalData.isCrawler);
  const { deviceType } = useSelector((state) => state.globalData);
  return (
    <StyledBox>
      <Grid
        container
        justifyContent="space-between"
        className="MTSTitleAndShareContiner">
        <Grid item lg={9} md={11} xs={10}>
          <Typography500 variant="h3" component="h2" className="MTSTitle">
            {t('fe_er_motorcycle_trip_page:page_motorcycle_trips', {
              page_name: experiencePageData.name,
            })}
          </Typography500>
        </Grid>
        {!isCrawler && (
          <Grid item lg={3} md={1} xs={2} textAlign="end">
            <ShareList />
          </Grid>
        )}
      </Grid>
      <Typography
        dangerouslySetInnerHTML={{ __html: experiencePageData.description }}
        variant="body1"
        component="p"
        className="MTSDesc"
      />
      <Box className="MTSGalleryContainer">
        <Typography500 variant="h4" component="h2" className="MTSGalleyTitle">
          {t('fe_er_motorcycle_trip_page:page_gallery', {
            page_name: experiencePageData.name,
          })}
          <CollectionsIcon className="MTSGalleyIcon" />
        </Typography500>
        <StyledGridsGallery
          ssrRender
          deviceType={deviceType}
          shouldResetAutoplay={false}
          slidesArray={prepareGalleryObject(
            experiencePageData.gallery.images,
            experiencePageData.gallery.video.youtube_vid,
          )}
          galleryHeight={{
            LG: '473px',
            MD: '444px',
            SM: '244px',
          }}
          variant="tours"
          sliderDots
        />
      </Box>
    </StyledBox>
  );
};

export { MotorcycleTripsSection };
